module.exports = __webpack_public_path__ + "static/img/building-top.36b5e09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/building-top.jpg
// module id = 324
// module chunks = 64